if (typeof Ancestry == 'undefined') { Ancestry = {}; }
if (typeof Ancestry.SUI == 'undefined') { Ancestry.SUI = {}; }

var recordPageSuggestedShowMore;

Ancestry.SUI.SuggestedRecords = (function () {

    function getSuggestedRecordUrl(recordUrl) {
        var rv = recordUrl.replace('&o_cvc=Image:OtherRecord', '&o_vc=Record:OtherRecord');
        if ('undefined' != typeof pc_tid && null != pc_tid) {
            rv += "&tid=" + pc_tid;
        }
        if ('undefined' != typeof pc_tpid && null != pc_tpid) {
            rv += "&tpid=" + pc_tpid;
        }

        // Add tracking query string variable
        if ('undefined' != typeof dbid && null != dbid) {
            rv += "&rhSource=" + dbid;
        }

        if (typeof indivRecord !== 'undefined' && indivRecord !== "") {
            rv += "&indivrecord=" + indivRecord;
        }

        return rv;
    }

    function finishRendering(theRecords) {
        var $theMainDiv = $("#rightColumn");
        var $partnerAttribution = $("#partnerAttribution");
        var theHtml = '<div class="conSecond"><div class="conHeader"><h2 class="conTitle">' + recordPageSuggestedHeaderLabel +
            ' <button class="seeMoreHelp link icon iconHelp" type="button" onclick="Ancestry.SUI.SuggestedRecords.ShowHelp()"></button></h2></div><div class="seeAlsoCta"><ul id="suggestedRecordList">';

        var rv = "";
        var maxSuggestions = 15;
        var initialShowSuggestions = 6;
        var totalSuggestions = 0;

        var showMoreHtml = "";
        var hiddenSuggestions = 0;

        if (theRecords != null) {
            for (var i = 0; i < theRecords.length; i++) {
                var theRecord = theRecords[i];
                if (!theRecord.LinkUrl) {
                    continue;
                }
                var thePrimaryName = theRecord.PrimaryName;
                if ('undefined' == typeof thePrimaryName || null == thePrimaryName) {
                    thePrimaryName = null;
                }
                var theLink = getSuggestedRecordUrl(theRecord.LinkUrl);
                var theDb = theRecord.LinkName;
                var nameHtml = (thePrimaryName != null) ? '<span>' + thePrimaryName + '</span>' : "";

                var recordHtml = '<li class="secondaryCta">' +
                    '<a href="' + theLink + '">' +
                    '<button class="link icon iconDocument">' + theDb +
                    '</button>' + nameHtml +
                    '</a>' +
                    '</li>';
                if (totalSuggestions < initialShowSuggestions) {
                    rv += recordHtml;
                } else {
                    hiddenSuggestions++;
                    showMoreHtml += recordHtml;
                }

                totalSuggestions++;
                if (totalSuggestions >= maxSuggestions) {
                    break;
                }
            }
        }

        if (totalSuggestions === 0) {
            return;
        }

        theHtml += rv;

        theHtml += '</ul>';

        if (hiddenSuggestions > 0) {
            theHtml += '<button style="padding: 8px 0 4px;" class="link icon iconArrowSmallDownAfter iconAfter" onclick="recordPageSuggestedShowMore(this)">' + recordPageSuggestedMoreLabel + '</button>';
        }

        recordPageSuggestedShowMore = function (element) {
            $(element).remove();
            $("#suggestedRecordList").append(showMoreHtml);
        };

        theHtml += '</div></div>' +
            '<div class="modal" data-title="' + recordPageSuggestedHelpTitleLabel + '" id="overlaySuggestedRecordsHelp">' +
            '<div>' +
            '	<h3>' + recordPageSuggestedHelpDescTitleLabel + '</h3>' +
            '	<p>' + recordPageSuggestedHelpDescLabel + '</p>' +
            '</div>';

        if ($partnerAttribution.length > 0) {
            $partnerAttribution.after(theHtml);
        } else {
            $theMainDiv.prepend(theHtml);
        }
    }



    return {

    ShowHelp: function () {
        $('#overlaySuggestedRecordsHelp').modal();
    },
    Render: function () {
        // If this variable isn't set then suggested records is turned off
        if (typeof recordPageSuggestedHeaderLabel === 'undefined')
            return;

        var recs = TGN.Ancestry.Search.RSDM.RecordSetDataModel.Records;
        
        if (recs != null && typeof recs['_' + pid] != 'undefined') {

            var theRecords = recs['_' + pid]['OtherRecords'];

            if (typeof ancestry != 'undefined' && ancestry.pub) {
                var totalRectified = 0;
                if (!theRecords) return;
                theRecords.forEach(function(theRecord, index) {
                    ancestry.pub.rectifyUrl(theRecord.LinkUrl, function(err, url) {
                        theRecords[index].LinkUrl = url;
                        totalRectified++;
                        if (totalRectified === theRecords.length) {
                            finishRendering(theRecords);
                        }
                    });
                });
            } else {
                finishRendering(theRecords);
            }          
        }
    },

    ShowRecordPageHints: function () {
        TGN.Ancestry.Search.RecordFeatures.RenderRecordHints();
    },

    //=========================== Shoebox saving and removing functions ====================================
    // Is this record saved in the shoebox?  Interpret the event and possibly the AJAX response to decide
    IsSavedInShoebox: function (eventName, pid, obj) {
        var isSaved;
        if (eventName == 'SaveRecordToShoebox')
            isSaved = true;
        else if (eventName == 'RemoveRecordFromShoebox')
            isSaved = false;
        else
            isSaved = (obj.DoesUserRecordActionExist(pid, obj.UserId, 'Shoeboxes'));
        return isSaved;
    },

    // Show message that record has been saved to shoebox
    ShowOrHideShoeboxMessage: function (eventName, pid, obj) {
        if (Ancestry.SUI.SuggestedRecords.IsSavedInShoebox(eventName, pid, obj)) {
            var savedToBoxMsgDiv = $('#savedToShoeBox');
            if ('undefined' != typeof savedToBoxMsgDiv) {
                savedToBoxMsgDiv.html('<div id="savedToBoxMsg" class="alert alertSuccess"><div class="shoeboxContent">' + savedToShoeboxMsg + "</div></div>");
                savedToBoxMsgDiv.show();
            }
        }
        else {
            $('#savedToBoxMsg').hide();;
        }
    },

    // Select the best option for saving in the save popup dialog
    SelectSaveBoxRadio: function () {
        var saveToMRVTr = document.getElementById('attachToPTNameRadio');
        var saveToMRV = document.getElementById('rdSave1');
        var saveToSomeoneElse = document.getElementById('rdSave2');
        var startTree = document.getElementById('rdSave4');
        if (('undefined' != typeof saveToMRVTr) && saveToMRVTr != null && saveToMRVTr.style.display != 'none')
            saveToMRV.checked = true;
        else if ('undefined' != typeof saveToSomeoneElse && saveToSomeoneElse != null) // will always be visible if it exists
            saveToSomeoneElse.checked = true;
        else if ('undefined' != typeof startTree && startTree != null) // will always be visible if it exists
            startTree.checked = true;
    },
    //=========================== Member Trees functions ====================================
    // Show message(s) that record has been saved to tree node(s)

    RemoveFromShoebox: function () {
        if (typeof (removeFromShoeboxUrl) === 'undefined') {
            removeFromShoeboxUrl = "/shoebox/remove";
        }
        if (confirm(removeShoeboxMsg)) {
            $.ajax({
                dataType: "jsonp",
                url: removeFromShoeboxUrl + "?op=remove&json=true&dbid=" + databaseId + "&unq=" + ((new Date()).getTime()) + "&pagetype=Record&rpid=" + recordPid + ((typeof isWatchBitRequest !== 'undefined' && isWatchBitRequest(location.href)) ? addWatchBitParameter(true) : ""),
                jsonpCallback: "Ancestry.SUI.SuggestedRecords.RemoveFromShoeboxCallback"
            });
        }
    },

    RemoveFromShoeboxCallback: function () {
        var shoeboxSave = {};
        shoeboxSave["UserId"] = TGN.Ancestry.Search.RSDM.RecordSetDataModel.UserId;
        TGN.Ancestry.Search.RSDM.RecordSetDataModel.RemoveRecordFromShoebox(pid, shoeboxSave);
    },
    GenerateTreesMessages: function (eventName, pid, obj) {
        var innerHtml = "";
        var records = obj.Records['_' + pid];
        var objLength = records && records['Trees'] ? records['Trees'].length : 0;
        var multipleSeparator;
        var singleLineClass;
        if (obj.DoesUserRecordActionExist(pid, obj.UserId, 'Trees')) {
            for (var i = 0; i < objLength; i++) {
                var treeSave = records['Trees'][i];
                multipleSeparator = (objLength > 1) ? ":" : "";
                singleLineClass = (i === 0) ? "firstLine" : "mutliline";
                if (treeSave == null)
                    continue;
                if (treeSave.UserId == obj.UserId) {
                    var treeUrl = savedTreeUrl.replace(/\{0\}/, treeSave.PersonId).replace(/\{1\}/, treeSave.TreeId);
                    var urlParams = "tid=" + treeSave.TreeId + "&pid=" + treeSave.PersonId + "&dbid=" + TGN.Ancestry.Search.RSDM.RecordSetDataModel.Dbid + "&rpid=" + pid + "&userdata=" + treeSave.PersonId;
                    innerHtml += '<div class="' + singleLineClass + '">' +
                                '<div class="treeInfo">' +
                                '<span class="personRecordSavedToText"><a href="' + treeUrl + '">' + treeSave.PersonName + '</a>&nbsp;</span>' +
                                inTreeText + '&nbsp;' +
                                '<span class="treeRecordSavedTo">"' + treeSave.TreeName + '"&nbsp;</span>' +
                                '</div>' +
                                '<div class="removeLink">' +
                                '<button class="link removeSaved" type="button" onclick="Ancestry.SUI.SuggestedRecords.RemoveFromTree(\'' + urlParams + '\')">' + removeTreeLink + '</button>' +
                                '</div>' +
                                '</div>';

                }
            }
        }
        if (innerHtml.length > 0) {
            innerHtml = '<div id="alreadySavedContainer" class="alert alertSuccess">' +
                            '<div class="savedHeader">' +
                                linkedTreeHdr + 
                                multipleSeparator +
                            '</div>' +
                            '<div class="savedContent">' +
                                innerHtml +
                            '</div>' +
                        '</div>';
            //If there is a container with content, remove this first, then append the new list of saved records.
            $("#alreadySavedContainer").remove();
            $("#savedRecords").append(innerHtml).show();
        }
        else {
            $("#savedRecords").hide();
        }
    },

    // Fire off the service request to remove the current record from the tree node where it is saved
    RemoveFromTree: function (urlParams) {
        if (confirm(detachRecMsg)) {
            $.ajax({
                dataType: "xml",
                url: "/mercury/pages/ajax/DetachRecordHdlr.ashx?" + urlParams,
                success: function(data) {
                    Ancestry.SUI.SuggestedRecords.OnCompleteRemoveFromTree(data);
                }
            });
        }
    },

    // AJAX callback when remove from tree is finished.
    OnCompleteRemoveFromTree: function (data) {
        var str, pid;
        var doc = data.documentElement;
        if (doc) {
            obj = doc.getElementsByTagName('detachrec')[0];
            if (obj) {
                str = obj.getAttribute('ret');
                if (str == "true") {
                    pid = obj.getAttribute('rpid');
                    // remove this tree item from the data model
                    var treeSave = {};
                    treeSave["UserId"] = TGN.Ancestry.Search.RSDM.RecordSetDataModel.UserId;
                    treeSave["PersonId"] = obj.getAttribute('userdata');
                    TGN.Ancestry.Search.RSDM.RecordSetDataModel.RemoveRecordFromTree(pid, treeSave);
                }
                else
                    alert(detachRecFailedMsg);
            }
        }
    },

    // Is this record saved to the Most Recently Viewed tree person?
    IsSavedToMRV: function (pid, obj) {
        for (var i = 0; i < obj.Records['_' + pid]['Trees'].length; i++) {
            var treeSave = obj.Records['_' + pid]['Trees'][i];
            if (treeSave == null)
                continue;
            if (treeSave.UserId == obj.UserId && treeSave.TreeId == mrvTid && treeSave.PersonId == mrvPid)
                return true;
        }
        return false;
    },

    UpdateCallToActionContent: function (eventName, pid, obj) {
        var calloutContent = $('<div class="ctaCalloutContent"></div>');
        var notSavedToPerson = havePersonalTree && ownMrvTree && !Ancestry.SUI.SuggestedRecords.IsSavedToMRV(pid, obj);

        if (notSavedToPerson) {
            calloutContent.append(htmlSaveToPersonLink);
        }

        if (!havePersonalTree) {
            calloutContent.append(htmlSaveAndCreateTreeLink);
        } else if (notSavedToPerson) {
            calloutContent.append(htmlSaveToSomeoneElseLink);
        } else {
            calloutContent.append(htmlSaveToSomeoneLink);
        }

        if (!Ancestry.SUI.SuggestedRecords.IsSavedInShoebox(eventName, pid, obj) && isLoggedIn) {
            calloutContent.append(htmlSaveToShoeboxLink);
        }
        if ($.callout.content) {
            $.callout.content($('.ctaCalloutTrigger'), calloutContent);
        } else {
            $('.ctaCalloutTrigger').callout('updateContent', calloutContent.html());
        }
    }
}})();